 import React from "react"
 const Errorpage =()=>{
    return(
        <h4 className="fw-bold mx-auto text-center">Page not found</h4>
    )
}

export default Errorpage

